import { ConfirmationModal } from "@platform/design-system";
import React from "react";

import { configurationLabel } from "./configurationRows";

import type { ConfigurationResponse } from "@platform/api";

interface DeleteConfigurationDialogProps {
  /** The configuration awaiting confirmation; `null` closes the dialog. */
  config: ConfigurationResponse | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: (id: string) => void;
}

// Brokers assigned to a deleted configuration fall back to the default one, so
// the count is worth stating before the delete goes through.
const assignmentWarning = (brokerCount: number): string => {
  if (brokerCount === 0) return "";

  const brokers = brokerCount === 1 ? "1 broker" : `${brokerCount} brokers`;

  return ` It is assigned to ${brokers}, who will fall back to the default MP config.`;
};

export const DeleteConfigurationDialog: React.FC<
  DeleteConfigurationDialogProps
> = ({ config, isDeleting, onCancel, onConfirm }) => {
  if (!config) return null;

  return (
    <ConfirmationModal
      open
      title="Delete MP Config?"
      description={`Are you sure you want to delete "${configurationLabel(config)}"? This cannot be undone.${assignmentWarning(config.brokerCount)}`}
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      onCancel={onCancel}
      onAccept={() => onConfirm(config.id)}
      loading={isDeleting}
      ConfirmButtonProps={{ variant: "danger" }}
      CancelButtonProps={{ variant: "tertiary" }}
    />
  );
};
